module.exports = __webpack_public_path__ + "img/donante-brigadas-de-belleza.1d414a44.png";